import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { Employee } from '@/types';
    import DataTableActions from '@/components/datatable/DataTableActions.vue';
    import ExportEmployeeChanges from '@/components/employees/ExportEmployeeChanges.vue';
    import OpenEmployeeChanges from '@/components/employees/OpenEmployeeChanges.vue';
    import EmployeeChangesRegistrated from '@/components/employees/EmployeeChangesRegistrated.vue';
    import EmployeeSalaryChangeRegistrated from '@/components/employees/EmployeeSalaryChangeRegistrated.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeChangesTableActions',
  props: {
    employee: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DataTableActions, { data: _ctx.employee }, {
    default: _withCtx(() => [
      _createVNode(OpenEmployeeChanges, { employee: _ctx.employee }, null, 8, ["employee"]),
      _createVNode(ExportEmployeeChanges, { employee: _ctx.employee }, null, 8, ["employee"]),
      (_ctx.employee.log && !_ctx.employee.log.changes_noted)
        ? (_openBlock(), _createBlock(EmployeeChangesRegistrated, { key: 0 }))
        : _createCommentVNode("", true),
      (_ctx.employee.unnoted_salary)
        ? (_openBlock(), _createBlock(EmployeeSalaryChangeRegistrated, {
            key: 1,
            "unnoted-salary": _ctx.employee.unnoted_salary
          }, null, 8, ["unnoted-salary"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }, 8, ["data"]))
}
}

})